/* Armadillo Hat Co. 2026 - storefront behaviour */
(function () {
  'use strict';
  var money = window.AHC && window.AHC.moneyFormat ? window.AHC.moneyFormat : '${{amount}}';

  function fmt(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    return money.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- panels (mobile nav + cart drawer) ---------- */
  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('button, a, input');
    if (f) f.focus();
  }
  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openPanel($('#' + o.getAttribute('data-open'))); return; }
    var c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closePanel(c.closest('.drawer, .mnav')); return; }
    if (e.target.classList && e.target.classList.contains('drawer__scrim')) closePanel(e.target.closest('.drawer'));
    if (e.target.classList && e.target.classList.contains('mnav__scrim')) closePanel(e.target.closest('.mnav'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { $$('.drawer.is-open, .mnav.is-open').forEach(closePanel); }
  });

  /* ---------- cart ---------- */
  function refreshCart() {
    return fetch('/?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-inner]');
        var target = $('[data-cart-inner]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (n) {
          n.textContent = cart.item_count;
          if (cart.item_count > 0) { n.removeAttribute('hidden'); } else { n.setAttribute('hidden', ''); }
        });
        return cart;
      });
  }

  function addToCart(id, qty, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.innerHTML = 'Adding'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || 'Could not add that one.');
        return refreshCart();
      })
      .then(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; }
        openPanel($('#cart-drawer'));
      })
      .catch(function (err) {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; }
        alert(err.message);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    var q = form.querySelector('[name="quantity"]');
    if (!id || !id.value) return;
    addToCart(id.value, q ? parseInt(q.value, 10) || 1 : 1, form.querySelector('[data-add-btn]'));
  });

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); addToCart(quick.getAttribute('data-quick-add'), 1, quick); return; }

    var chg = e.target.closest('[data-line-change]');
    if (chg) {
      e.preventDefault();
      var line = chg.getAttribute('data-line');
      var to = parseInt(chg.getAttribute('data-line-change'), 10);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: to })
      }).then(function () {
        if (document.body.classList.contains('tpl-cart')) { window.location.reload(); }
        else { refreshCart(); }
      });
    }
  });

  /* ---------- qty steppers ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-qty]');
    if (!s) return;
    var input = s.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += parseInt(s.getAttribute('data-qty'), 10);
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gal-main] img');
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gal-thumb]');
      if (!t || !main) return;
      main.src = t.getAttribute('data-src');
      main.srcset = t.getAttribute('data-srcset') || '';
      main.alt = t.getAttribute('data-alt') || main.alt;
      $$('[data-gal-thumb]', g).forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
    });
  });

  /* ---------- variants ---------- */
  $$('[data-variant-picker]').forEach(function (picker) {
    var root = picker.closest('[data-product-root]');
    if (!root) return;
    var data = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    var idField = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var btn = root.querySelector('[data-add-btn]');
    var stock = root.querySelector('[data-stock]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function selected() {
      return $$('input:checked', picker).map(function (i) { return i.value; });
    }
    function update() {
      var opts = selected();
      var match = data.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];

      $$('[data-opt-current]', picker).forEach(function (el, i) {
        if (opts[i]) el.textContent = opts[i];
      });

      if (!match) {
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Unavailable'; }
        return;
      }
      if (idField) idField.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = match.compare > match.price
          ? '<s>' + fmt(match.compare) + '</s> <span class="sale">' + fmt(match.price) + '</span>'
          : fmt(match.price);
      }
      if (stickyPrice) stickyPrice.textContent = fmt(match.price);
      if (btn) {
        if (match.available) {
          btn.removeAttribute('aria-disabled');
          btn.textContent = btn.getAttribute('data-label') || 'Add to cart';
        } else {
          btn.setAttribute('aria-disabled', 'true');
          btn.textContent = 'Sold out';
        }
      }
      if (stock) {
        if (match.available && match.qty > 0 && match.qty <= 8) {
          stock.innerHTML = 'Only <strong>' + match.qty + '</strong> left in this one.';
        } else if (match.available) {
          stock.textContent = 'In stock. Ships from Texas in 1 to 2 business days.';
        } else {
          stock.textContent = 'Sold out for now. More on the way.';
        }
      }
      if (history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }
    picker.addEventListener('change', update);
    update();
  });

  /* ---------- sticky buy bar ---------- */
  var sticky = $('[data-sticky-buy]');
  var anchor = $('[data-add-form]') || $('[data-buy-anchor]');
  if (sticky && anchor) {
    var syncSticky = function () {
      sticky.classList.toggle('is-on', anchor.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky);
    syncSticky();
    sticky.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-add]')) {
        e.preventDefault();
        var form = $('[data-add-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });
  }

  /* ---------- sort ---------- */
  var sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
